(function () {
  'use strict';

  /* mr-reviews-anchor.js -- RC3 (2026-07-13), item 1.
     Makes the Judge.me stars+review-count widget under the product title
     (block key judgeme_preview_badge -- Shopify auto-assigns its wrapper
     id as "...__judgeme_preview_badge", confirmed live) an accessible,
     keyboard-activatable control that smoothly scrolls to whichever
     Judge.me review-display widget is actually active further down the
     page (store summary, reviews grid, cards carousel, or classic review
     widget -- confirmed live that ALL of Judge.me's own review-display
     blocks carry a [data-widget-name] attribute). The scroll TARGET is
     found generically at runtime, not by any hardcoded Shopify section
     id -- section ids are auto-generated and can change if Akkas
     reorders/reconfigures blocks in Theme Editor. Scrolls to the
     enclosing section wrapper ("stable wrapper"), not to an individual
     review card, so it works even before Judge.me has finished
     hydrating the cards inside. Does not create a second reviews widget
     -- purely adds a click/keydown affordance on top of the existing,
     unmodified Judge.me markup. */

  function findReviewSection() {
    var widgets = document.querySelectorAll('[data-widget-name]');
    for (var i = 0; i < widgets.length; i++) {
      var name = widgets[i].getAttribute('data-widget-name');
      if (name && name !== 'preview_badge') {
        return widgets[i].closest('[id^="shopify-section-"]') || widgets[i];
      }
    }
    return null;
  }

  function scrollToReviews(event) {
    var target = findReviewSection();
    if (!target) return;
    if (event) event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function wireBadge(badge) {
    if (badge.hasAttribute('data-mr-reviews-wired')) return;
    badge.setAttribute('data-mr-reviews-wired', 'true');
    badge.setAttribute('role', 'link');
    badge.setAttribute('tabindex', '0');
    badge.setAttribute('aria-label', 'See customer reviews');
    badge.classList.add('mr-reviews-link');
    badge.addEventListener('click', function (e) { scrollToReviews(e); });
    badge.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews();
      }
    });
  }

  function init(root) {
    root = root || document;
    var badge = root.querySelector('[id$="__judgeme_preview_badge"]');
    if (badge) wireBadge(badge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.MRReviewsAnchor = { init: init };
})();
